import {Projection, Transform} from '../redux/projections-slice';
import {isStaticSite, storage} from "../electron-modules";

export const unknownProjectionMeters = {
  type: 'proj4',
  default: true,
  units: "m",
  name: "unknown-projection-m",
  string: '+proj=utm +zone=10 +ellps=WGS84 +datum=WGS84 +units=m',
} as Projection;

export const unknownProjectionFeet = {
  type: 'proj4',
  default: true,
  units: "ft",
  name: "unknown-projection-ft",
  string: '+proj=utm +zone=10 +ellps=WGS84 +datum=WGS84 +units=ft',
};

export const defaultProjection = {
  type: 'proj4',
  name: '',
  string: ''
} as Projection;

export const defaultTransform = {
  origin: Array(3).fill(0),
  translation: Array(3).fill(0),
  rotation: 0,
  scale: 1
} as Transform;

export const uniqueProjectionID = (text) => {
  return text.replace(/\s/g, '.');
};

class UserProjections {
    public data: Projection[] = [];

    constructor() {
      this.load();
    }

    exists(name: string) {
      const names = this.data.map(x => x.name);
      return names.includes(name);
    }

    save(data: Projection) {
      if (this.exists(data.name)) return false;

      this.data.push(data);
      const result = storage.set('projection', this.data);

      if (result.status) {
        this.load();
        return true;
      }

      return false;
    }

    load() {
      if (isStaticSite) return {};

      const result = storage.get("projection");
      const projections = result.status ? result.data : [];

      // Data has get/set methods instead of raw values
      // so we dump and load json values to get raw data
      this.data = projections.map(obj => {
        return JSON.parse(JSON.stringify(obj));
      });
    }

    delete(name: string) {
      if (!this.exists(name)) return;

      const rows = this.data.map(x => x.name);
      const index = rows.indexOf(name);
      this.data.splice(index, 1);

      const result = storage.set('projection', this.data);
      if (result.status) {
        this.load();
      }
    }

    update(name: string, data: Projection) {
      if (!this.exists(name)) return false;
      this.delete(name);
      return this.save(data);
    }
}

export const userProjections = new UserProjections();
